import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from '../../../../layout/styledcomponents/CustomButton';
import ReleaseNotesSettingsForm from '../../../components/7DAY Admin Components/ReleaseNotes/ReleaseNotesSettingsForm';

const ReleaseNotesSettingsPage = () => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const navigate = useNavigate();
    const theme = useTheme();

    const handleBackButton = () => {
        navigate(-1);
    };

    const backButton = (
        <CustomButton
            onClick={handleBackButton}
            color='primary'
            sx={{
                alignSelf: 'flex-start',
                ml: { xs: -1, sm: -1 },
                '&:hover': {
                    cursor: 'pointer',
                    color: theme.palette.textAccent.main,
                    backgroundColor: 'transparent',
                    background: 'none',
                },
            }}
        >
            <ArrowBackIcon />
            {!isMobile ? (
                <Typography sx={{ fontSize: '12px', pl: '5px' }}>
                    Back to Admin Centre
                </Typography>
            ) : null}
        </CustomButton>
    );

    return (
        <Stack
            spacing={{ xs: 2, sm: 3 }}
            sx={{
                width: '100%',
                minWidth: 0,
                px: { xs: 1, sm: 0 },
                pb: { xs: 3, sm: 0 },
            }}
        >
            {isMobile ? backButton : null}
            <ReleaseNotesSettingsForm />
            {!isMobile ? backButton : null}
        </Stack>
    );
};
export default ReleaseNotesSettingsPage;
